import { render } from "./SuspendUserForm.vue?vue&type=template&id=ea803ad2"
import script from "./SuspendUserForm.vue?vue&type=script&lang=js"
export * from "./SuspendUserForm.vue?vue&type=script&lang=js"

import "./SuspendUserForm.vue?vue&type=style&index=0&id=ea803ad2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__